/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tabs/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tabs({
  children,
  viewPath = "/App/Account/WaitingRoom/Content/Content/Checkout/Tabs",
  onChange
  
}) {
  let flow = fromFlow.useFlow()
let tabsValueData = fromData.useDataValue({ viewPath,
context: 'tabs',
})
let selectedTabValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'tab',
})
let selectedTabChangeData = fromData.useDataChange({ viewPath,
context: 'selected',
path: 'tab',
})
  return (<React.Fragment
>
<div
  data-testid="Tabs.Vertical"
  data-view-path={viewPath}
 style={{'--v-1-brpv': flow.has(fromFlow.normalizePath(viewPath, '../Appointments/No')) ? "hidden" : "visible"}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 allowEmptyChoice={false}
 marginTop={0}
 size="small"
 data="tabs"
 from={tabsValueData}
 data="selected.tab"
 value={selectedTabValueData}
 onChange={selectedTabChangeData}
>
{childProps => (
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
)}
</TysiaSelect>
</div>
{children}
</React.Fragment>)
}